import Immutable from "immutable";
import { floatToMoney } from "lib/money";

export const DinnerItem = new Immutable.Record({
  id: undefined,
  name: undefined,
  price: undefined,
  availability: undefined,
  allowFSMPurchase: undefined,
  allergyInformation: undefined
}, "Dinner Item");

export const staticOptions = {
  NONE: { name: "None", isFree: true },
  MEAL: { name: "Meal", isFree: false },
  MEAT: { name: "Meat", isFree: false },
  VEG: { name: "Veg", isFree: false },
  SANDWICH: { name: "Packed", isFree: true }
}

function buildDinnerItemFromAppserverCashless(rawDinnerItem) {
  return DinnerItem({
    id: rawDinnerItem.dinner_item_fk,
    name: rawDinnerItem.name,
    price: floatToMoney(rawDinnerItem.cost),
    availability: new Immutable.List([
      rawDinnerItem.available_monday,
      rawDinnerItem.available_tuesday,
      rawDinnerItem.available_wednesday,
      rawDinnerItem.available_thursday,
      rawDinnerItem.available_friday
    ]),
    allowFSMPurchase: !rawDinnerItem.prevent_fsm_purchase,
    allergyInformation: rawDinnerItem.allergy_information
  });
}

function buildDinnerItemFromAppserverNonCashless(rawDinnerBooking, status) {
  const { name, isFree } = staticOptions[status];
  return DinnerItem({
    id: status,
    name,
    price: isFree ? 0 : floatToMoney(rawDinnerBooking.cost_per_dinner),
    availability: new Immutable.List([ true, true, true, true, true ]),
    allowFSMPurchase: true,
    allergyInformation: ""
  });
}

DinnerItem.staticOptions = staticOptions;
DinnerItem.fromAppserverCashless = buildDinnerItemFromAppserverCashless;
DinnerItem.fromAppserverNonCashless = buildDinnerItemFromAppserverNonCashless;
export default DinnerItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/DinnerBooking/DinnerItem.js